import SecondaryPagesImage from '../../components/SecondaryPagesImage';
import SecondaryPagesBanner from '../../components/SecondaryPagesBanner';
import { Trans, withTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import slide1 from '../../images/slide1.jpeg';
//import parents from '../../images/parents.jpeg';
import ourTeam from '../../images/our-team.jpeg';

function MessageFromHT() {
    let { pathname } = useLocation();

   pathname = pathname.replace('/', '')
   const rootSection = pathname.split('/')[0]

    const MAIN_BLOCK_DATA = {
       'admissions': {
          header: `Admissions`,
          text: `admissions.welcome_text`
       },
       'gallery': {
          header: `Gallery`,
          image: slide1,
          text: `The Gallery is full of a wealth of photographs`
       },
       'calendar': {
          header: 'Calendar',
          image: slide1,
          text: ''
       },
       'satellite-schools': {
          header: 'satellite schools',
          text: 'satellite schools addition'
          //image: parents,
          //text: 'satellite schools addition'
       },
       'contact-us': {
          header: 'Contact Us',
          image: ourTeam,
          text: 'Our Address'
       }
    };

    let style = {textAlign: 'center', fontSize: '18px' };
    


    return(
      <>
      <div className={`page-${pathname}`}>
         <SecondaryPagesImage image={MAIN_BLOCK_DATA[rootSection].image} />
         <SecondaryPagesBanner header={<Trans i18nKey={MAIN_BLOCK_DATA[rootSection].header} customStyle={style}/>}
         text={<Trans i18nKey={MAIN_BLOCK_DATA[rootSection].text}/>} />
         <Outlet />
      </div>

      </>
    );
}

export default withTranslation()(MessageFromHT);